<template>
    <div class="v-text-field__details" v-if="messages.length > 0">
        <div :class="['v-messages', `${type}--text`]" role="alert">
            <div class="v-messages__wrapper">
                <div class="v-messages__message" v-for="(message, i) in messages" :key="i">
                    {{ message }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        messages: {
            type: Array,
            default: () => {
                return []
            },
        },
        type: {
            type: String,
            default: 'error'
        }
    },
};
</script>
